module.exports = __webpack_public_path__ + "static/img/rank3.8af875b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/rank/rank3.png
// module id = VpKC
// module chunks = 0